import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function CourseSection() {
  const {
    t
  } = useLanguage();
  return <section className="w-full py-24 bg-white relative overflow-hidden" data-id="element-78">
      {/* Marble Background */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rL7dK7UH3wwQa67MzLqofL/textura-de-marmol-blanco-y-dorado-natural-para-tapiceria-tela-piel-fondo-lujo-interiores-paredes-arte-ceramica-piedra-creativa-268157195.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      opacity: 0.5
    }} data-id="element-79"></div>
      <div className="absolute inset-0 bg-white/60 backdrop-blur-sm pointer-events-none" data-id="element-80"></div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10" data-id="element-81">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20" data-id="element-82">
          {/* Left Column: Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 relative" data-id="element-83">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] max-w-md mx-auto" data-id="element-84">
              <img src="https://cdn.magicpatterns.com/uploads/5pbYVurd75xq1bwvCVduuC/Captura_de_Pantalla_2026-04-10_a_la(s)_14.03.13.png" alt="Curso de Micropigmentación" className="w-full h-full object-cover" data-id="element-85" />
              <div className="absolute inset-0 border border-[#D4AF37]/30 rounded-2xl m-4 pointer-events-none" data-id="element-86"></div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border border-[#D4AF37]/30 rounded-full -z-10" data-id="element-87"></div>
            <div className="absolute -top-6 -right-6 w-24 h-24 border border-[#D4AF37]/30 rounded-full -z-10" data-id="element-88"></div>
          </motion.div>

          {/* Right Column: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="w-full md:w-1/2 flex flex-col justify-center text-center md:text-left" data-id="element-89">
            <div className="flex items-center justify-center md:justify-start gap-4 mb-6" data-id="element-90">
              <div className="w-8 h-[1px] bg-[#D4AF37]" data-id="element-91"></div>
              <h2 className="font-serif text-sm tracking-[0.3em] uppercase text-[#C9956A]" data-id="element-92">
                {t('course_label')}
              </h2>
              <div className="w-8 h-[1px] bg-[#D4AF37] md:hidden" data-id="element-93"></div>
            </div>

            <h3 className="font-serif text-4xl md:text-5xl text-[#2C1810] mb-6 leading-tight" data-id="element-94">
              {t('course_title')}
            </h3>

            <p className="text-[#5C3D2E] font-light leading-relaxed mb-8 text-lg" data-id="element-95">
              {t('course_desc')}
            </p>

            <p className="font-medium text-[#2C1810] mb-8 italic" data-id="element-96">
              {t('course_cta_text')}
            </p>

            <div data-id="element-97">
              <a href={`https://wa.me/5493412720732?text=${encodeURIComponent(t('course_msg'))}`} target="_blank" rel="noopener noreferrer" className="animate-breathe inline-block px-10 py-4 rounded-full bg-gold-gradient text-white font-medium tracking-wide shadow-[0_4px_20px_rgba(212,175,55,0.3)] transition-all hover:shadow-[0_6px_25px_rgba(212,175,55,0.5)] hover:scale-105" data-id="element-98">
                {t('course_btn')}
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}